import Link from 'next/link';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { all_cities, cn } from '../../../utils';
import { quickLinks, services } from '../../../utils/footer';
import useLoginRoute from '../../hooks/useLoginRoute';

const FooterItem = ({ label, options, listStyle = '', ...props }) => {
  return (
    <div {...props}>
      <h2 className='mb-4 text-[18px] font-semibold text-white'>{label}</h2>
      <div className={listStyle}>
        {options.map((item, index) => (
          <ListItem
            key={index}
            link={item.url}
            label={item.label || item.name}
          />
        ))}
      </div>
    </div>
  );
};
const ListItem = ({ label, link }) => {
  return (
    <Link
      href={link ? link : '#'}
      className='h-[22px] max-w-[200px] truncate text-[14px] text-white'
    >
      {label}
    </Link>
  );
};
const SocialIcons = ({ className }) => {
  const router = useRouter();
  const { city } = router.query;
  const selectedCity = all_cities.find((item) => item.name === city);

  if (selectedCity?.fb_link && selectedCity?.insta_link)
    return (
      <div className={cn('mb-[27px] flex gap-x-[18px] md:hidden', className)}>
        <Link href={selectedCity?.fb_link}>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g clipPath='url(#clip0_33779_15187)'>
              <path
                d='M24 12.0301C24 5.38947 18.624 0 12 0C5.376 0 0 5.38947 0 12.0301C0 17.8526 4.128 22.7008 9.6 23.8195V15.6391H7.2V12.0301H9.6V9.02256C9.6 6.70075 11.484 4.81203 13.8 4.81203H16.8V8.42105H14.4C13.74 8.42105 13.2 8.96241 13.2 9.62406V12.0301H16.8V15.6391H13.2V24C19.26 23.3985 24 18.2737 24 12.0301Z'
                fill='white'
              />
            </g>
            <defs>
              <clipPath id='clip0_33779_15187'>
                <rect width='24' height='24' fill='white' />
              </clipPath>
            </defs>
          </svg>
        </Link>
        <Link href={selectedCity?.insta_link}>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <rect width='24' height='24' rx='12' fill='white' />
            <path
              d='M12.0019 6.09763C13.9258 6.09763 14.1516 6.10621 14.912 6.14051C15.6153 6.17196 15.9955 6.28916 16.2499 6.38922C16.5872 6.52071 16.8273 6.67508 17.0789 6.92664C17.3305 7.17821 17.4877 7.41833 17.6163 7.75565C17.7135 8.01007 17.8336 8.39028 17.865 9.0935C17.8993 9.85391 17.9079 10.0797 17.9079 12.0036C17.9079 13.9275 17.8993 14.1533 17.865 14.9137C17.8336 15.617 17.7164 15.9972 17.6163 16.2516C17.4848 16.5889 17.3305 16.829 17.0789 17.0806C16.8273 17.3321 16.5872 17.4894 16.2499 17.618C15.9955 17.7152 15.6153 17.8353 14.912 17.8667C14.1516 17.901 13.9258 17.9096 12.0019 17.9096C10.078 17.9096 9.85221 17.901 9.09181 17.8667C8.38858 17.8353 8.00838 17.7181 7.75396 17.618C7.41664 17.4865 7.17651 17.3321 6.92495 17.0806C6.67338 16.829 6.51616 16.5889 6.38752 16.2516C6.29032 15.9972 6.17026 15.617 6.13882 14.9137C6.10451 14.1533 6.09594 13.9275 6.09594 12.0036C6.09594 10.0797 6.10451 9.85391 6.13882 9.0935C6.17026 8.39028 6.28747 8.01007 6.38752 7.75565C6.51902 7.41833 6.67338 7.17821 6.92495 6.92664C7.17651 6.67508 7.41664 6.51786 7.75396 6.38922C8.00838 6.29202 8.38858 6.17196 9.09181 6.14051C9.85221 6.10335 10.0809 6.09763 12.0019 6.09763ZM12.0019 4.7998C10.0466 4.7998 9.80076 4.80838 9.03178 4.84268C8.26566 4.87699 7.74252 4.99991 7.28514 5.17715C6.8106 5.3601 6.41039 5.6088 6.01018 6.00902C5.60996 6.40923 5.36412 6.8123 5.17831 7.28398C5.00107 7.74136 4.87815 8.26449 4.84384 9.03347C4.80954 9.79959 4.80096 10.0454 4.80096 12.0008C4.80096 13.9561 4.80954 14.2019 4.84384 14.9709C4.87815 15.737 5.00107 16.2602 5.17831 16.7204C5.36126 17.1949 5.60996 17.5951 6.01018 17.9954C6.41039 18.3956 6.81346 18.6414 7.28514 18.8272C7.74252 19.0045 8.26566 19.1274 9.03464 19.1617C9.80361 19.196 10.0466 19.2046 12.0048 19.2046C13.963 19.2046 14.2059 19.196 14.9749 19.1617C15.741 19.1274 16.2642 19.0045 16.7244 18.8272C17.199 18.6443 17.5992 18.3956 17.9994 17.9954C18.3996 17.5951 18.6454 17.1921 18.8313 16.7204C19.0085 16.263 19.1314 15.7399 19.1657 14.9709C19.2 14.2019 19.2086 13.9589 19.2086 12.0008C19.2086 10.0426 19.2 9.79959 19.1657 9.03061C19.1314 8.26449 19.0085 7.74136 18.8313 7.28112C18.6483 6.80658 18.3996 6.40637 17.9994 6.00616C17.5992 5.60595 17.1961 5.3601 16.7244 5.17429C16.267 4.99705 15.7439 4.87413 14.9749 4.83983C14.2031 4.80838 13.9572 4.7998 12.0019 4.7998Z'
              fill='#181519'
            />
            <path
              d='M12.0019 8.30469C9.96082 8.30469 8.3028 9.95985 8.3028 12.0038C8.3028 14.0477 9.95796 15.7029 12.0019 15.7029C14.0458 15.7029 15.701 14.0477 15.701 12.0038C15.701 9.95985 14.0458 8.30469 12.0019 8.30469ZM12.0019 14.4022C10.6755 14.4022 9.60062 13.3273 9.60062 12.0009C9.60062 10.6745 10.6755 9.59966 12.0019 9.59966C13.3283 9.59966 14.4032 10.6745 14.4032 12.0009C14.4032 13.3273 13.3283 14.4022 12.0019 14.4022Z'
              fill='#181519'
            />
            <path
              d='M15.8468 9.0196C16.3236 9.0196 16.7101 8.63308 16.7101 8.15628C16.7101 7.67949 16.3236 7.29297 15.8468 7.29297C15.37 7.29297 14.9835 7.67949 14.9835 8.15628C14.9835 8.63308 15.37 9.0196 15.8468 9.0196Z'
              fill='#181519'
            />
          </svg>
        </Link>
      </div>
    );
  else return null;
};

const Footer = () => {
  const lang = useSelector(({ common }) => common?.language);
  const router = useRouter();
  const { city } = router.query;
  const { isAuthenticated } = useLoginRoute();
  const currentYear = new Date().getFullYear();
  const breakingNews = useSelector(({ common }) => common?.breakingNews);
  const citiesWithLink = all_cities.map((item) => {
    return {
      label: item.name,
      url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/market?city=${item.name}`,
    };
  });

  const servicelistStyle =
    'md:h-[80px]  flex flex-col flex-wrap xxl:gap-x-[64px] gap-y-2';
  const citieslistStyle =
    'h-[192px] md:h-[111px] xxl:h-[90px]  flex flex-col flex-wrap gap-x-[48px] xxl:gap-x-[64px] gap-y-2';
  return (
    <div
      className={cn('w-full bg-black', breakingNews ? 'mb-[40px]' : 'mb-[0px]')}
    >
      <footer className='mx-auto  w-full max-w-[1440px] px-4 py-[32px] pt-[32px] lg:px-[172px] xxl:py-[56px]'>
        <div className='mb-[88px] flex flex-col gap-6 md:flex-row lg:gap-[72px] xxl:gap-[118px]'>
          <FooterItem
            className='w-full md:w-[301px] xxl:w-[320px]'
            label={lang?.common?.service}
            listStyle={servicelistStyle}
            options={services({ city, lang, isAuthenticated })}
          />
          {citiesWithLink && (
            <FooterItem
              className='w-[175px] md:w-[307px] xxl:w-[442px]'
              label={lang?.common?.cities}
              listStyle={citieslistStyle}
              options={citiesWithLink}
            />
          )}
        </div>
        <SocialIcons className='mb-[27px] flex gap-x-[18px] md:hidden' />

        <div className='mb-[88px] flex w-full flex-col gap-6 md:mb-0 md:flex-row lg:gap-[72px] xxl:gap-[118px]'>
          <div className='hidden w-full md:flex md:w-[307px] xxl:w-[320px]'>
            <p className='text-[14px]  text-white '>
              &copy;{` by Ron Orp ${currentYear}`}
            </p>
            <SocialIcons className='ml-[78px] hidden gap-x-[18px]  md:flex' />
          </div>

          <div className='flex h-[114px] w-[129px] flex-col  flex-wrap gap-[24px] md:h-[22px] md:w-[400px] md:flex-row xxl:w-[442px]'>
            {quickLinks(lang).map((item, index) => (
              <ListItem key={index} link={item.url} label={item.label} />
            ))}
          </div>
          <p className='block text-[14px] text-white  md:hidden '>
            &copy;{` by Ron Orp ${currentYear}`}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
